
document.addEventListener('DOMContentLoaded', function() {

  /* Larghezze gestite via CSS, nessun allineamento JS */
  var priceCard = document.querySelector('.fx-price-card');
  if (priceCard) { priceCard.style.opacity = '1'; }

  var product = window.productData;
  if (!product) return;

  var images = [];
  var currentIndex = 0;
  var userInteracting = false;

  /* Mappa variant_id -> immagine per navigazione colore */
  var variantImageMap = {};
  if (product.variants) {
    product.variants.forEach(function(v) {
      if (v.featured_image && v.featured_image.src) {
        variantImageMap[String(v.id)] = v.featured_image.src;
      }
    });
  }

  /* Raccogli immagini */
  if (product.images && product.images.length > 0) {
    product.images.forEach(function(img) {
      var url = img.src || img.url || img;
      if (typeof url === 'string') images.push({ url: url, alt: img.alt || product.title });
    });
  }
  if (images.length === 0 && product.featured_image) {
    images.push({ url: product.featured_image, alt: product.title });
  }
  if (images.length === 0) return;

  function resizeUrl(url, size) {
    if (!url || url.indexOf('shopify') === -1) return url;
    return url.replace(/(_\d+x\d+)?\.(jpg|jpeg|png|webp|gif)/i, '_' + size + '.$2');
  }

  /* Crea carousel */
  function createCarousel(containerId, imgSize) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var track = container.querySelector('.fx-carousel-track');
    if (!track) return;
    track.innerHTML = '';
    images.forEach(function(img, i) {
      var item = document.createElement('div');
      item.className = 'fx-carousel-item';
      if (i === 0) item.classList.add('fx-item-current');
      else if (i === 1 && images.length > 1) item.classList.add('fx-item-next');
      else if (i === images.length - 1 && images.length > 2) item.classList.add('fx-item-prev');
      var el = document.createElement('img');
      el.loading = i === 0 ? 'eager' : 'lazy';
      el.src = resizeUrl(img.url, imgSize);
      el.alt = img.alt;
      el.style.cursor = 'pointer';
      item.appendChild(el);
      track.appendChild(item);
    });
  }

  createCarousel('fxProductCarousel', '600x600');
  createCarousel('fxProductCarouselMobile', '400x400');

  /* Dots */
  document.querySelectorAll('.fx-carousel-dots').forEach(function(dc) {
    dc.innerHTML = '';
    images.forEach(function(_, i) {
      var dot = document.createElement('span');
      dot.className = 'fx-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', function() { goToImage(i); });
      dc.appendChild(dot);
    });
  });

  function updateCarousel() {
    ['fxProductCarousel', 'fxProductCarouselMobile'].forEach(function(id) {
      var c = document.getElementById(id);
      if (!c) return;
      c.querySelectorAll('.fx-carousel-item').forEach(function(item, i) {
        item.classList.remove('fx-item-current', 'fx-item-prev', 'fx-item-next');
        if (i === currentIndex) item.classList.add('fx-item-current');
        else if (i === (currentIndex + 1) % images.length) item.classList.add('fx-item-next');
        else if (i === (currentIndex - 1 + images.length) % images.length) item.classList.add('fx-item-prev');
      });
    });
    document.querySelectorAll('.fx-dot').forEach(function(d) {
      d.classList.toggle('active', parseInt(d.getAttribute('data-index')) === currentIndex);
    });
  }

  function nextImage() {
    if (images.length <= 1) return;
    userInteracting = true;
    currentIndex = (currentIndex + 1) % images.length;
    updateCarousel();
    setTimeout(function() { userInteracting = false; }, 3000);
  }

  function prevImage() {
    if (images.length <= 1) return;
    userInteracting = true;
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateCarousel();
    setTimeout(function() { userInteracting = false; }, 3000);
  }

  function goToImage(idx) {
    if (idx < 0 || idx >= images.length || idx === currentIndex) return;
    userInteracting = true;
    currentIndex = idx;
    updateCarousel();
    setTimeout(function() { userInteracting = false; }, 3000);
  }

  /* VONDOM: mostra swatch colore/tessuto nel carosello */
  var swatchSlideIndex = -1;
  window.vondomShowSwatch = function(swatchUrl, colorName) {
    if (!swatchUrl) return;
    /* Se c'è già uno swatch slide, aggiorna l'immagine */
    if (swatchSlideIndex >= 0 && swatchSlideIndex < images.length) {
      images[swatchSlideIndex] = { url: swatchUrl, alt: colorName || 'Colore' };
      /* Aggiorna l'img element nei carousel */
      ['fxProductCarousel', 'fxProductCarouselMobile'].forEach(function(id) {
        var c = document.getElementById(id);
        if (!c) return;
        var items = c.querySelectorAll('.fx-carousel-item');
        if (items[swatchSlideIndex]) {
          var img = items[swatchSlideIndex].querySelector('img');
          if (img) { img.src = swatchUrl; img.alt = colorName || 'Colore'; }
        }
      });
    } else {
      /* Aggiungi nuovo slide alla fine */
      swatchSlideIndex = images.length;
      images.push({ url: swatchUrl, alt: colorName || 'Colore' });
      ['fxProductCarousel', 'fxProductCarouselMobile'].forEach(function(id) {
        var c = document.getElementById(id);
        if (!c) return;
        var track = c.querySelector('.fx-carousel-track');
        if (!track) return;
        var item = document.createElement('div');
        item.className = 'fx-carousel-item';
        var img = document.createElement('img');
        img.src = swatchUrl;
        img.alt = colorName || 'Colore';
        img.style.objectFit = 'cover';
        item.appendChild(img);
        track.appendChild(item);
      });
      /* Aggiungi dot */
      document.querySelectorAll('.fx-carousel-dots').forEach(function(dc) {
        var dot = document.createElement('span');
        dot.className = 'fx-dot';
        dot.setAttribute('data-index', swatchSlideIndex);
        dot.addEventListener('click', function() { goToImage(swatchSlideIndex); });
        dc.appendChild(dot);
      });
    }
    /* Naviga allo swatch slide */
    currentIndex = swatchSlideIndex;
    updateCarousel();
  };

  /* Click navigation */
  ['fxProductCarousel', 'fxProductCarouselMobile'].forEach(function(id) {
    var carousel = document.getElementById(id);
    if (!carousel) return;
    carousel.addEventListener('click', function(e) {
      var item = e.target.closest('.fx-carousel-item');
      if (!item || images.length <= 1) return;
      if (item.classList.contains('fx-item-prev')) prevImage();
      else if (item.classList.contains('fx-item-next')) nextImage();
      else if (item.classList.contains('fx-item-current')) {
        var zoomModal = document.getElementById('fxImageZoomModal');
        var zoomImg = document.getElementById('fxZoomImage');
        if (zoomModal && zoomImg) {
          zoomImg.src = images[currentIndex].url;
          zoomModal.style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      }
    });
  });

  /* Touch/Swipe */
  ['fxProductCarousel', 'fxProductCarouselMobile'].forEach(function(id) {
    var carousel = document.getElementById(id);
    if (!carousel) return;
    var startX = 0, startY = 0, swiping = false;
    carousel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; swiping = true;
    }, {passive: true});
    carousel.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      var dx = startX - e.touches[0].clientX, dy = startY - e.touches[0].clientY;
      if (Math.abs(dy) > Math.abs(dx)) { swiping = false; return; }
      if (Math.abs(dx) > 10) e.preventDefault();
    }, {passive: false});
    carousel.addEventListener('touchend', function(e) {
      if (!swiping) return;
      var diff = startX - e.changedTouches[0].clientX;
      var threshold = window.innerWidth <= 768 ? 30 : 50;
      if (Math.abs(diff) > threshold) { if (diff > 0) nextImage(); else prevImage(); }
      swiping = false;
    }, {passive: true});
  });

  /* Auto-rotate */
  if (images.length > 1) {
    setInterval(function() { if (!userInteracting) nextImage(); }, 5000);
  }

  /* Zoom modal */
  var zoomModal = document.getElementById('fxImageZoomModal');
  var zoomImg = document.getElementById('fxZoomImage');
  var zoomIdx = 0;
  function closeZoom() { if (zoomModal) { zoomModal.style.display = 'none'; document.body.style.overflow = ''; } }
  var zc = document.getElementById('fxZoomClose');
  var zb = document.getElementById('fxZoomBackdrop');
  var zp = document.getElementById('fxZoomPrev');
  var zn = document.getElementById('fxZoomNext');
  if (zc) zc.addEventListener('click', closeZoom);
  if (zb) zb.addEventListener('click', closeZoom);
  if (zp) zp.addEventListener('click', function() { zoomIdx = (zoomIdx - 1 + images.length) % images.length; zoomImg.src = images[zoomIdx].url; });
  if (zn) zn.addEventListener('click', function() { zoomIdx = (zoomIdx + 1) % images.length; zoomImg.src = images[zoomIdx].url; });

  /* Funzione per navigare carousel all'immagine della variante */
  function goToVariantImage(variantId) {
    var imgUrl = variantImageMap[String(variantId)];
    if (!imgUrl || images.length === 0) return;
    for (var i = 0; i < images.length; i++) {
      if (images[i].url.indexOf(imgUrl.split('/').pop().split('?')[0].split('.')[0]) > -1 ||
          imgUrl.indexOf(images[i].url.split('/').pop().split('?')[0].split('.')[0]) > -1) {
        goToImage(i);
        return;
      }
    }
  }
  window.fxGoToVariantImage = goToVariantImage;

  /* Aggiungi navigazione colore agli swatches */
  document.querySelectorAll('.fx-color-swatch, .fx-imex-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.dataset.variantId) goToVariantImage(btn.dataset.variantId);
    });
  });

  /* ── SELETTORE COLORE ── */
  var colorBtns = document.querySelectorAll('.fx-color-opt');
  var priceEl = document.getElementById('heroPriceValue');
  var variantInput = document.getElementById('fxVariantId');
  var skuEl = document.getElementById('fxSku');
  var selectedColorEl = document.getElementById('fxSelectedColor');

  colorBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      colorBtns.forEach(function(b) { b.classList.remove('fx-color-active'); });
      btn.classList.add('fx-color-active');
      variantInput.value = btn.dataset.variantId;
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (skuEl) skuEl.textContent = btn.dataset.sku || '';
      if (selectedColorEl) selectedColorEl.textContent = btn.dataset.option1;
    });
  });

  /* Quantita */
  var qtyInput = document.getElementById('fxQty');
  var qtyHidden = document.getElementById('fxQtyHidden');
  var qm = document.getElementById('fxQtyMinus');
  var qp = document.getElementById('fxQtyPlus');
  if (qm) qm.addEventListener('click', function() { var v = parseInt(qtyInput.value)||1; if(v>1){qtyInput.value=v-1;qtyHidden.value=v-1;} });
  if (qp) qp.addEventListener('click', function() { var v = parseInt(qtyInput.value)||1; if(v<99){qtyInput.value=v+1;qtyHidden.value=v+1;} });
  if (qtyInput) qtyInput.addEventListener('change', function() { var v=parseInt(qtyInput.value)||1; if(v<1)v=1;if(v>99)v=99; qtyInput.value=v;qtyHidden.value=v; });

  /* Add to cart AJAX */
  var form = document.getElementById('fxAddToCartForm');
  if (form) form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = document.getElementById('fxAddToCart');
    var tEl = btn.querySelector('.fx-config-btn-title');
    var orig = tEl.textContent;
    tEl.textContent = 'AGGIUNTA IN CORSO...';
    btn.style.pointerEvents = 'none';
    fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: parseInt(variantInput.value), quantity: parseInt(qtyHidden.value||1) })
    }).then(function(r){return r.json();}).then(function() {
      tEl.textContent = 'AGGIUNTO!'; btn.style.background = '#2ecc71';
      setTimeout(function(){tEl.textContent=orig;btn.style.background='';btn.style.pointerEvents='';}, 2000);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      var ci = document.querySelector('[data-cart-toggle], .Header__CartIcon, a[href="/cart"]');
      if (ci) setTimeout(function(){ci.click();}, 300);
    }).catch(function(){
      tEl.textContent='ERRORE - RIPROVA'; btn.style.background='#e74c3c';
      setTimeout(function(){tEl.textContent=orig;btn.style.background='';btn.style.pointerEvents='';}, 2000);
    });
  });

  /* ── ACCORDION TOGGLE — ritardato per sovrascrivere il configuratore ── */
  setTimeout(function() {
    ['specsToggle','descToggle'].forEach(function(toggleId) {
      var toggle = document.getElementById(toggleId);
      if (!toggle) return;
      var acc = toggle.closest('.fx-specs-accordion');
      var cont = acc ? acc.querySelector('.fx-specs-content') : null;
      var neo = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(neo, toggle);
      neo.addEventListener('click', function(e) {
        e.preventDefault();
        if (acc) acc.classList.toggle('active');
        if (cont) cont.style.display = acc.classList.contains('active') ? 'block' : 'none';
      });
    });
  }, 3000);

});
